const NEXT_ICON =
	'<svg xmlns="http://www.w3.org/2000/svg" height="40" width="40" viewBox="0 0 640 640"><path fill="#ffffff" d="M64 320C64 461.4 178.6 576 320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320zM305 441C295.6 450.4 280.4 450.4 271.1 441C261.8 431.6 261.7 416.4 271.1 407.1L358.1 320.1L271.1 233.1C261.7 223.7 261.7 208.5 271.1 199.2C280.5 189.9 295.7 189.8 305 199.2L409 303C418.4 312.4 418.4 327.6 409 336.9L305 441z"/></svg>';
const PREV_ICON =
	'<svg xmlns="http://www.w3.org/2000/svg" height="40" width="40" viewBox="0 0 640 640"><path fill="#ffffff" d="M576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576C461.4 576 576 461.4 576 320zM335 199C344.4 189.6 359.6 189.6 368.9 199C378.2 208.4 378.3 223.6 368.9 232.9L281.9 319.9L368.9 406.9C378.3 416.3 378.3 431.5 368.9 440.8C359.5 450.1 344.3 450.2 335 440.8L231 337C221.6 327.6 221.6 312.4 231 303.1L335 199z"/></svg>';

export default class AboutHospitalCarouselController {
	constructor(jQueryRef) {
		this.$ = jQueryRef;
		this.initialized = false;
	}

	init() {
		if (this.initialized || !this.$ || typeof this.$.fn.owlCarousel === 'undefined') {
			return;
		}

		const wrapper = document.querySelector('.aboutHospitalCoreValueSection-playout .wrapper');
		if (!wrapper) {
			return;
		}

		this.initialized = true;
		const countCarousel = parseInt(wrapper.getAttribute('data-count-carousel'), 10) || 0;

		for (let index = 0; index < countCarousel; index += 1) {
			this.initCarousel(this.$(`#aboutHospitalCoreValue-${index}`), {
				autoplayTimeout: 3000,
				items: 1,
				loop: true,
				margin: 10,
				dots: false,
				dotsEach: false,
			});
		}
	}

	initCarousel($element, config = {}) {
		if (!$element.length) {
			return;
		}

		if ($element.data('owl.carousel')) {
			$element.trigger('destroy.owl.carousel');
			$element.removeClass('owl-loaded');
			$element.find('.owl-stage-outer').children().unwrap();
		}

		$element.on('initialized.owl.carousel refreshed.owl.carousel', (event) => {
			this.decorateDots(this.$(event.target));
		});

		$element.owlCarousel({
			items: 1,
			loop: true,
			lazyLoad: true,
			autoplay: true,
			autoplayHoverPause: false,
			dots: true,
			dotsEach: true,
			nav: true,
			navText: [PREV_ICON, NEXT_ICON],
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			smartSpeed: 600,
			autoWidth: false,
			stagePadding: 0,
			margin: 0,
			...config,
		});

		this.decorateDots($element);
	}

	decorateDots($target) {
		$target.find('.owl-dot').each((index, dot) => {
			const label = `Slide ${index + 1}`;
			const $button = this.$('<button type="button" class="tmhq-dot-btn"></button>')
				.attr('aria-label', label)
				.text(index + 1);

			this.$(dot).empty().append($button);
		});
	}
}
